import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-multi-station-visitee-maintenance",
	templateUrl: "./multi-station-visitee-maintenance.component.html",
	styleUrls: ["./multi-station-visitee-maintenance.component.css"],
})
export class MultiStationVisiteeMaintenanceComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////

	SelectMode: string = "Manual"; //Manual | Batch

	////////////////////////////////////////////////////////////
}
